import React, { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLocation } from '@thd-olt-component-react/router';

export const hydrateProps = (props, ctx) => {
  const { channel } = ctx.expContext;
  const { store } = ctx;
  let path = ctx.pathname;
  if (!path && typeof window !== 'undefined') {
    path = window.location.pathname;
  }
  const updatedProps = Object.keys(props).reduce((acc, cur) => {
    const val = props[cur];

    if (val === '$channel') {
      return {
        ...acc,
        [cur]: channel,
      };
    }

    if (val === '$itemId') {
      let itemId = '';

      if (ctx.itemId) {
        itemId = ctx.itemId;
      } else if (/(?:\/[\w-]+)?\/p(?:\/[\w-]+)?\/\d+/.test(path)) {
        [, itemId] = /(?:\/[\w-]+)?\/p(?:\/[\w-]+)?\/(\d+)/.exec(path);
      } else if (/\/config\/[a-f0-9-]+\/[^/]+\/(\d+)$/.test(path)) {
        [, itemId] = /\/config\/[a-f0-9-]+\/[^/]+\/(\d+)$/.exec(path);
      }
      return {
        ...acc,
        [cur]: itemId,
      };
    }

    if (val === '$paintReorderConfigId') {
      let paintReorderConfigId = '';

      if (ctx.paintReorderConfigId) {
        paintReorderConfigId = ctx.paintReorderConfigId;
      } else if (/\/config\/([a-f0-9-]+)\//.test(path)) {
        [, paintReorderConfigId] = /\/config\/([a-f0-9-]+)\//.exec(path);
      }
      return {
        ...acc,
        [cur]: paintReorderConfigId,
      };
    }

    if (val === '$storeId') {
      return {
        ...acc,
        [cur]: store.storeId,
      };
    }

    if (val === '$storeZip') {
      return {
        ...acc,
        [cur]: store.storeZip,
      };
    }

    if (val === '$pathname') {
      return {
        ...acc,
        [cur]: path,
      };
    }

    // support nested objects
    if (typeof val === 'object') {
      if(Array.isArray(val)){
        return {
          ...acc,
          [cur]: val.map(item => hydrateProps(item, ctx)),
        }
      } else {
        return {
          ...acc,
          [cur]: hydrateProps(val, ctx),
        };
      }
    }
    return {
      ...acc,
      [cur]: val,
    };
  }, {});
  return updatedProps;
};

export const useHydratedProps = (component, opts = {}) => {
  const expContext = useContext(ExperienceContext);
  const store = useStore();
  const { pathname } = useLocation();

  const ctx = {
    store,
    expContext,
    pathname,
    itemId: opts.itemId,
  };

  if (Array.isArray(component)) {
    const ret = component.map((comp) => hydrateProps(comp.props, ctx));
    if (opts.mergeArray) {
      return ret.reduce((acc, cur) => {
        return {
          ...acc,
          ...cur,
        };
      });
    }
    return ret;
  }
  return hydrateProps(component.props, ctx);
};